export const certificateFileGroup = [
    {
        name:'ISO',
        code:'VMA12',
        isRequire:false,
        isAdditional:false
    },
    {
        name:'TQA',
        code:'VMA13',
        isRequire:false,
        isAdditional:false
    },
    {
        name:'TISI',
        code:'VMA14',
        isRequire:false,
        isAdditional:false
    },
    {
        name:'Other',
        code:'VMA15',
        isRequire:false,
        isAdditional:false
    },
]